import { Button, ButtonProps } from "@mui/material";
import { colors } from "utils/consts";

interface Props extends ButtonProps {
    action?: () => void;
};

const ConfirmationButton = ({ action, sx, ...props }: Props) => {
    return (
        <Button
            onClick={action}
            variant="contained"
            {...props}
            sx={{
                background: colors.homeBlue,
                borderRadius: 7,
                textTransform: "none",
                fontSize: "16px",
                py: 1.2,
                px: 2,
                ...sx
            }}
        />
    );
}

export default ConfirmationButton;